<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="newGroup">
            <van-loading
                class="pageLogin"
                v-if="isloading"
                type="spinner"
                color="#1989fa"
            ></van-loading>
            <van-nav-bar
                title="选择联系人"
                left-arrow
                left-text="通讯录"
                right-text="确认"
                @click-left="onClickLeft"
                @click-right="confirmationPersonnel"
            >
            </van-nav-bar>
            <section>
                <van-search v-model="value" placeholder="请输入搜索信息" @change="search"></van-search>
                <div class="list">
                    <dl>
                        <dd>
                            <van-index-bar :index-list="indexList" :sticky="false">
                                <van-checkbox-group v-model="result">
                                    <template v-for="(item, index) in contactsData">
                                        <van-index-anchor :index="item.Initial" :key="index"></van-index-anchor>
                                        <template v-for="k in item.data">
                                            <van-checkbox :name="k" :key="k.friend_id">
                                                <van-cell>
                                                    <img class="van_left" src="@/assets/images/addressBook/icon_group_1@2x.png" alt="头像">
                                                    <div class="van_left info">
                                                        <p>{{ k.friend_name }}</p>
                                                        <span>{{ k.friend_org_name }}</span>
                                                    </div>
                                                </van-cell>
                                            </van-checkbox>
                                        </template>
                                    </template>
                                </van-checkbox-group>
                            </van-index-bar>
                        </dd>
                    </dl>
                </div>
            </section>
        </div>
    </v-touch>
</template>

<script>

export default {
    // 新增群组
    name: 'new-group',
    components: {},
    props: {},
    data() {
        return {
            // 搜索框内容
            value: '',
            // 联系人数据
            contactsData: [],
            // loading层状态
            isloading: false,
            // 选择人员集合
            result: [],
            // 已注册人员数据集合
            registered: [],
            // 已注册人员id数据集合
            registeredId: [],
            // 未注册人员数据集合
            unregistered: [],
            // 索引数组
            indexList: [],
        };
    },
    computed: {},
    watch: {},
    created() {
        // 获取好友列表
        this.getFriends();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 确认选择人员
        confirmationPersonnel() {
            const callMobileData = [];
            this.result.forEach(item => {
                callMobileData.push(item);
            });
            // 过滤已选择人员书否注册
            this.filterPersonSelected(callMobileData);
        },
        // 过滤已选择人员书否注册
        filterPersonSelected(data) {
            data.forEach(item => {
                if (item.friend_acc_id !== '') {
                    this.registeredId.push(item.friend_acc_id);
                } else {
                    this.unregistered.push(item.friend_name);
                }
            });

            if (this.unregistered.length > 0) {
                this.$dialog({ message: this.unregistered + '，用户未注册！' });
            }

            if (this.registeredId.length > 0) {
                this.$callMobile('JYTeamsNative', 'CreatedTeamMembersInfo', this.registeredId);
            }
        },
        // 搜索人员
        search() {
            if (this.value === '') {
                this.getFriends();
            } else {
                const searchContactsData = [];
                this.contactsData.forEach(item => {
                    item.data.forEach(k => {
                        if (k.friend_name.indexOf(this.value) !== -1 || k.Intiials.indexOf(this.value) !== -1) {
                            searchContactsData.push(k);
                        }
                    });
                });
                // 处理数据
                const newData = this.$dataSorting(searchContactsData, 'User_Name');
                // 常用联系人数据赋值
                this.contactsData = newData.dataList;
                // 索引数组赋值
                this.indexList = newData.indexList;
            }
        },
        // 获取好友列表
        getFriends() {
            this.isloading = 1;
            this.$axios
                .get('/interfaceApi/message/MessageNetease/get_friends')
                .then(res => {
                    // 处理数据
                    const newData = this.$dataSorting(res, 'friend_name');
                    this.contactsData = newData.dataList;
                    // 索引数组赋值
                    this.indexList = newData.indexList;
                    this.isloading = false;
                }).catch(error => {
                    this.isloading = false;
                    this.$dialog({ message: error });
                });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
};
</script>
<style lang="stylus">
.newGroup
    section
        height calc(100% - 44rpx)
        .list
            height calc(100% - 44rpx)
            overflow-y scroll
            -webkit-overflow-scrolling: touch;
            dl
                // overflow hidden
                position relative
                &:nth-of-type(1)
                    dt
                        border-top 0
            dd
                .van-checkbox
                    padding-left 10rpx
                    border-bottom 1px solid #F0F0F0
                    .van-checkbox__label
                        margin-left 20rpx
                .van-cell
                    height 60rpx
                    padding 10rpx 15rpx
                    padding-left 0
                    &:after
                        left 0
                    img
                        width 40rpx
                        height 40rpx
                        margin-right 10rpx
                    .info
                        width calc(100% - 50rpx)
                        p,span
                            width 100%
                            float left
                        p
                            font-size 18rpx
                            line-height 18rpx
                            color #333333
                            margin-bottom 8rpx
                        span
                            font-size 12rpx
                            line-height 12rpx
                            color #979EA7
                .van-index-anchor
                    background #F9F9F9
    .van-nav-bar__right
        .van-nav-bar__text
            color #fff
            &:active
                background-color rgba(0,0,0,0)
</style>